import React from 'react'
import MainProjectFeed from './MainProjectFeed'
import AvailableProjects from './AvailableProjects'

function ProjectFeed() {
  return (
    <div className='flex flex-col lg:flex-row'>
      <div className='w-full lg:w-[70%]'>
      <MainProjectFeed />
      </div>
      
      <div className='w-full lg:w-[30%] my-10 lg:my-0'>
      <AvailableProjects />
      </div>
    </div>
  )
}

export default ProjectFeed
